module.exports = {
  "zones": {
    "Asia/Ho_Chi_Minh": ["z", {
      "wallclock": 171849600000,
      "format": "+07",
      "abbrev": "+07",
      "offset": 25200000,
      "posix": 171820800000,
      "save": 0
    }, {
      "wallclock": -315622800000,
      "format": "+08",
      "abbrev": "+08",
      "offset": 28800000,
      "posix": -315648000000,
      "save": 0
    }, {
      "wallclock": -457747200000,
      "format": "+07",
      "abbrev": "+07",
      "offset": 25200000,
      "posix": -457776000000,
      "save": 0
    }, {
      "wallclock": -718070400000,
      "format": "+08",
      "abbrev": "+08",
      "offset": 28800000,
      "posix": -718095600000,
      "save": 0
    }, {
      "wallclock": -767836800000,
      "format": "+07",
      "abbrev": "+07",
      "offset": 25200000,
      "posix": -767869200000,
      "save": 0
    }, {
      "wallclock": -782614800000,
      "format": "+09",
      "abbrev": "+09",
      "offset": 32400000,
      "posix": -782643600000,
      "save": 0
    }, {
      "wallclock": -852080400000,
      "format": "+08",
      "abbrev": "+08",
      "offset": 28800000,
      "posix": -852105600000,
      "save": 0
    }, {
      "wallclock": -1851552000000,
      "format": "+07",
      "abbrev": "+07",
      "offset": 25200000,
      "posix": -1851577590000,
      "save": 0
    }, {
      "wallclock": -2004048000000,
      "format": "PLMT",
      "abbrev": "PLMT",
      "offset": 25590000,
      "posix": -2004073600000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 25600000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};